import { FormArray, FormGroup } from '@angular/forms'

export function updateFormValidity(formGroup: FormGroup | FormArray, markAsTouched = true): void {
  const controlNames = Object.keys(formGroup.controls)
  for (const controlName of controlNames) {
    const control = formGroup.get(controlName)

    if (control instanceof FormGroup || control instanceof FormArray) {
      updateFormValidity(control)
    } else if (control != null) {
      control.updateValueAndValidity({ onlySelf: true })

      if (markAsTouched) {
        control.markAsTouched({ onlySelf: true })
      }
    }
  }

  // need to call it on the form afterwards
  formGroup.updateValueAndValidity()
}
